import React from "react";
import { TouchableWithoutFeedback, View } from "react-native";

const Overlay = ({
  children,
  onClose,
}: {
  children: React.ReactNode;
  onClose: () => void;
}) => {
  return (
    <View
      style={{
        position: "absolute",
        overflow: "hidden",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 99,
      }}
    >
      <TouchableWithoutFeedback onPress={onClose}>
        <View
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.2)",
          }}
        />
      </TouchableWithoutFeedback>
      {children}
    </View>
  );
};

export default Overlay;
